var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEyeClosed = function SvgEyeClosed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#747474",
    d: "M2.796.293a1 1 0 1 0-1.414 1.414l2.424 2.424C2.376 5.207 1.128 6.685.194 8.553a1 1 0 0 0 0 .894C2.353 13.764 6.186 16 10.09 16c1.555 0 3.1-.355 4.53-1.055l2.763 2.762a1 1 0 0 0 1.414-1.414zm10.307 13.135c-.98.383-2 .572-3.014.572-2.969 0-6.002-1.62-7.87-5 .817-1.479 1.858-2.62 3.018-3.437l2.144 2.144a3 3 0 0 0 4.001 4.001zM16.641 10.896c.483-.556.926-1.187 1.318-1.896-1.868-3.38-4.901-5-7.87-5q-.168 0-.336.007L7.968 2.223A10.2 10.2 0 0 1 10.088 2c3.904 0 7.737 2.236 9.895 6.553a1 1 0 0 1 0 .894 13 13 0 0 1-1.925 2.865z"
  })));
};
export default SvgEyeClosed;